exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hrORY{border:none;padding:5px 0;color:var(--neutral--800);color:var(--neutral--800)}._1Pich{display:block;margin-left:26px;border-left:1px solid var(--primary--400);border-left:1px solid var(--primary--400);padding-left:5px}", ""]);

// exports
exports.locals = {
	"section": "hrORY",
	"subsection": "_1Pich"
};